<template>
  <div class="form-group">
    <label class="form-label" :class="{ required }">{{ label }}</label>
    <div class="gender custom-radio">
      <span class="text-muted" v-if="placeholder && modelValue == null">{{ placeholder }}</span>
      <div class="flex radio-group">
        <div class="form-check form-check-inline" v-for="option in options" :key="option[optionValue]">
          <input class="form-check-input" type="radio" :id="`${name}-${option[optionValue]}`" :name="name"
            :value="option[optionValue]" :disabled="disabled" v-model="internalValue" :required="required" />
          <label class="form-check-label"  style="margin: 10px;" :for="`${name}-${option[optionValue]}`">
            {{ option[optionLabel] }}
          </label>
        </div>
      </div>
    </div>
    <small class="text-danger" v-if="error">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: "InputRadio",
  props: {
    modelValue: null,
    label: { type: String, default: "" },
    name: { type: String, required: true },
    options: { type: Array, required: true },
    placeholder: { type: String, default: "" },
    error: { type: String, default: "" },
    required: { type: Boolean, default: false },
    optionValue: { type: String, default: "value" },
    optionLabel: { type: String, default: "label" },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
        this.$emit('change', value);
      }
    }
  }
};
</script>
